"use client"

import { signIn } from "next-auth/react"

interface Props {
  callbackUrl: string
}

export function SignInButton({ callbackUrl }: Props) {
  return (
    <button
      type="button"
      onClick={() => signIn("zitadel", { callbackUrl })}
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        padding: "14px 24px",
        backgroundColor: "#111827",
        color: "#ffffff",
        border: "none",
        borderRadius: 8,
        fontSize: 15,
        fontWeight: 600,
        cursor: "pointer",
        letterSpacing: "0.01em",
      }}
    >
      <LockIcon />
      Sign in securely
    </button>
  )
}

function LockIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  )
}
